export var noSpacesValidator = function (value) {
    return [' ', '\t', '\n'].every(function (invalidChar) { var _a; return !((_a = value === null || value === void 0 ? void 0 : value.includes) === null || _a === void 0 ? void 0 : _a.call(value, invalidChar)); });
};
//# sourceMappingURL=no-spaces-validator.js.map